import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import OnboardingPlannerViewSectionHeader
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/OnboardingPlannerViewSectionHeader';
import { useOnboardingPlannerViewSectionContext } from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/ViewSectionContext';
import {
  FDStack,
} from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import fr from 'facet-rest';
import ReviewAccountStatementButton
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/BalanceSheet/UploadedAccountStatementsComponents/ReviewAccountStatementsButton';
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';
import BalanceSheetLayout from './StepLayout';

const BalanceSheetOverride = fr.metaOverride({ base: BaseOverride });

function ViewSectionLayout() {
  const {
    resource,
  } = useMetaLayoutContext();

  const {
    onAddTask,
    onAddNote,
  } = useOnboardingPlannerViewSectionContext();

  const [balanceSheetStepResource] = resource.attr('sectionData');

  return (
    <FDStack direction={'column'} paddingX={3}>
      <OnboardingPlannerViewSectionHeader
        title={resource.attr('title')}
        onAddTask={onAddTask}
        onAddNote={onAddNote}
      />
      <FDStack direction={'column'} paddingX={2} paddingY={4} spacing={2}>
        <ReviewAccountStatementButton relationship={balanceSheetStepResource.relationship(fr.relationships.uploadedAccountStatements.name)} />
        <MetaResourceRenderer
          key={'balanceSheet'} // eslint-disable-line react/no-array-index-key
          resource={balanceSheetStepResource}
          metaOverrideSet={BalanceSheetOverride}
          layout={BalanceSheetLayout}
        />
      </FDStack>
    </FDStack>
  );
}

ViewSectionLayout.propTypes = {
};

ViewSectionLayout.defaultProps = {
};

export default ViewSectionLayout;
